import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { Bank } from "../../model/domain/Bank";
import { DomainService } from "../../services/domain.service";

@Component({
  selector: "app-select-bank",
  templateUrl: "./banco.component.html",
  styleUrls: ["./banco.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class BankComponent implements OnInit, AfterViewInit {
  @Input() banks: Bank[] = null;
  @Input() codeBank: string = null;
  @Input() readOnly = false;
  @Input() dataCy = "bankId";
  @Input() name = "bankId";
  selectedBankIdValue: string;
  @Input()
  get selectedBankId() {
    return this.selectedBankIdValue;
  }
  set selectedBankId(val: string) {
    this.selectedBankIdValue = val;
    this.selectedBankIdChange.emit(val);
  }
  @Output() selectedBankIdChange: EventEmitter<string> =
    new EventEmitter<string>();

  constructor(private domainService: DomainService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.banks == null) {
      this.domainService.ListBanks().subscribe((b) => {
        this.banks = b;
      });
    }
  }
}
